export enum NEON_GRID_CONTAINER_CLASS {
  GridContainer = '__neon__grid-container',
}
export enum NeonGridColumn {
  Two = '__neon__grid-col-2',
  MediumFour = '__neon__grid-col-md-4',
  LargeFour = '__neon__grid-col-lg-4',
}
export const NEON_TEXT = '__neon__text';
export const DATA_SLOT = 'body';
export const CARD_ACTIONS_SLOT = 'card-actions';
export enum NEON_ADD_DOCUMENT_ILLUSTRATION {
  AddDocument = 'add-document',
}
export enum NeonIllustrationBackground {
  Complex = 'complex',
  Simple = 'simple',
  None = 'none',
}

export enum NeonButtonTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Utility = 'utility',
  Borderless = 'borderless',
}
export const MAX_SUBJECT_AREA_NAME_LENGTH = 50;
